export { default } from './NewProductFeaturesBadge'
